import { useEffect, useState } from 'react'
import { HiSpeakerWave, HiMiniSpeakerXMark } from 'react-icons/hi2'
import { useSelector } from 'react-redux'
import { retrunAssets } from '../utils/getAssets'

const Hero = () => {
  const state = useSelector(state => state.homepage)
  const [isMute, setIsMute] = useState(true)
  const [videoSource, setVideoSource] = useState('')
  const [isMobile, setIsMobile] = useState(false)

  const poster = '/assets/poster.svg'
  const mobileVideo = '/assets/hero_mobile.mp4'

  // Set initial video source based on screen size and available video
  useEffect(() => {
    const checkIfMobile = () => {
      const mobile = window.innerWidth < 768
      setIsMobile(mobile)
      return mobile
    }

    // Set initial mobile state
    const mobile = checkIfMobile()

    // Get video URL from state if available
    const videoUrl = state?.data?.properties?.introductoryVideo?.[0]?.url
      ? retrunAssets(state.data.properties.introductoryVideo[0].url)
      : ''

    // Set appropriate video source
    setVideoSource(mobile ? mobileVideo : videoUrl)

    // Add resize event listener
    const handleResize = () => {
      const nowMobile = checkIfMobile()
      setVideoSource(prev => {
        const videoUrl = state?.data?.properties?.introductoryVideo?.[0]?.url
          ? retrunAssets(state.data.properties.introductoryVideo[0].url)
          : ''
        return nowMobile ? mobileVideo : videoUrl
      })
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [state?.data?.properties?.introductoryVideo])

  return (
    <div className='relative w-full h-screen bg-slate-200'>
      <video
        key={videoSource} // This forces re-render when source changes
        src={videoSource}
        id='bgVideo'
        preload='auto'
        autoPlay
        loop
        muted={isMute}
        poster={poster}
        className='fixed w-full h-full inset-0 object-cover aspect-square'
      >
        <track kind='captions'></track>
      </video>

      <div
        className='fixed bottom-16 2xl:bottom-28 2xl:right-10 2xl:w-12 2xl:h-12 right-5 bg-black/40 p-3 rounded-lg cursor-pointer text-white'
        onClick={() => setIsMute(prev => !prev)}
      >
        {isMute ? (
          <HiMiniSpeakerXMark size={25} />
        ) : (
          <HiSpeakerWave size={25} />
        )}
      </div>
    </div>
  )
}

export default Hero